'use client';

import {
  BRAND_GRADIENT,
  BRAND_GRADIENT_DARK_GLASS
} from '@repo/brand';

interface FaqItemProps {
  question: string
  answer: string
  isOpen: boolean
  onToggle: () => void
}

export default function FaqItem({
  question, answer, isOpen, onToggle
}: FaqItemProps) {

  return (
    <div className="bg-white dark:bg-gray-900 rounded-xl overflow-hidden border border-gray-100 dark:border-gray-800 shadow-sm">
      <button
        className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left"
        onClick={onToggle}
        aria-expanded={isOpen}
      >
        <span className="text-sm font-semibold text-[#0a1628] dark:text-white">{question}</span>
        <span
          className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center transition-all duration-300 ${ isOpen ? BRAND_GRADIENT_DARK_GLASS : 'bg-[#f3f4f6] dark:bg-gray-700' }`}
          style={isOpen
            ? {
              background: BRAND_GRADIENT
            }
            : undefined}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
            className={`w-3 h-3 transition-transform duration-300 ${ isOpen ? 'fill-white' : 'fill-[#6b7280] dark:fill-gray-400' }`}
            style={{
              transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)'
            }}
          >
            <path d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z" />
          </svg>
        </span>
      </button>

      {/* CSS grid trick for smooth height transition */}
      <div
        className="grid transition-all duration-300 ease-in-out"
        style={{
          gridTemplateRows: isOpen ? '1fr' : '0fr'
        }}
      >
        <div className="overflow-hidden">
          <div className="px-6 pb-5 text-sm text-gray-500 dark:text-gray-400 leading-relaxed">
            {answer}
          </div>
        </div>
      </div>
    </div>
  );
}
